import { $body } from '../global';
class DropdownManager {
    dropdownSelector;
    init(selector) {
        if (!$(selector).length)
            return;
        (async () => {
            await import('selectize/dist/js/selectize.min.js');
            // console.log(selectize);
            this.dropdownSelector = selector;
            this.initInContainer($body, selector);
        })();
    }
    static setZIndexToWrapperElement(dropdown, zIndex) {
        const wrapperSelector = '.js-GridItem_Wrapper';
        const wrapper = dropdown.closest(wrapperSelector);
        if (!wrapper.length)
            return;
        wrapper.css({ zIndex });
    }
    static setOverflowGrid(dropdown, overflow) {
        dropdown.closest('.js-Grid').css({ overflow });
    }
    initInContainer(container, selector = undefined) {
        selector = selector || this.dropdownSelector;
        const $selectize = container.find(selector);
        if ($selectize.length) {
            $selectize.each(function () {
                const $this = $(this);
                if ($this.data('placeholder') && !$this.find('option[selected]').length) {
                    const placeholder = $(this).data('placeholder');
                    const placeholderOption = `<option value="" selected>${placeholder}</option>`;
                    $this.prepend($(placeholderOption));
                }
                $(this).selectize({
                    maxItems: 1,
                    render: {
                        item: function (item, escape) {
                            const itemLabel = escape(item.text);
                            return `<div class="item Selectize-Item" data-value="${item.value}">${itemLabel}</div>`;
                        }
                    },
                    /*
                     *  All the wrapper elements (grid blocks) are absolute positioned.
                     *  When opening the dropdown it is not entirely visible, because a sibling is stacked above (because it is also absolute positioned)
                     *  This function will add a z-index to the parent element and remove it when the dropdown closes.
                     */
                    onDropdownOpen(dropdown) {
                        DropdownManager.setZIndexToWrapperElement(dropdown, 1);
                        DropdownManager.setOverflowGrid(dropdown, 'visible');
                    },
                    onDropdownClose(dropdown) {
                        DropdownManager.setZIndexToWrapperElement(dropdown, 'auto');
                        DropdownManager.setOverflowGrid(dropdown, '');
                    }
                });
                $this.on('click', () => {
                    $this.val('');
                });
            });
        }
    }
}
const dropdownManager = new DropdownManager();
export { DropdownManager, dropdownManager };
